<template>
  <div class="row">
    <div class="col-xl-12 col-lg-12">
      <div>
        <div class="card">
          <div class="card-header" v-if="isAdmin">
            <a-button type="primary" @click="goToNew">
              + Tambah Farmasi
            </a-button>
          </div>
          <div class="card-body">
            <TabelFarmasi />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TabelFarmasi from '@/components/tables/farmasi'
import router from '@/router'

export default {
  components: {
    TabelFarmasi,
  },
  data: function () {
    return {
      isAdmin: false,
    }
  },
  created() {
    this.getRole()
  },
  methods: {
    getRole() {
      const role = window.localStorage.getItem('role')
      // console.log(role)
      if (role === 'admin' || role === 'apl' || role === 'astrazeneca') {
        this.isAdmin = true
      }
    },
    goToNew() {
      router.push('/farmasi/tambah')
    },
  },
}
</script>
